export default __webpack_public_path__ + "maps-examples-style-circles-categorically-960-95f2b100215e45464def07acb387bc08.webp";